"use client";

import React, { RefObject } from "react";

import { PopoverTrigger } from "@nextui-org/react";
import { useTranslations } from "next-intl";
import { useMediaQuery } from "react-responsive";

import SearchLocation from "@/components/ui/SearchPanel/SearchModals/SearchLocation";
import { DealType } from "@/enums/dealType";
import { Filter } from "@/types/SearchFilter.types";
import { RegionData } from "@/types/store/location.types";
import SearchLocationInput from "@/ui/SearchPanel/SearchModals/SearchLocation/SearchLocationInput";

import { Popover, PopoverContent } from "./SearchPopover";
import styles from "./style.module.scss";

interface SearchLocationClassicProps {
  selectedFilters: Filter;
  setSelectedFilters: React.Dispatch<React.SetStateAction<Filter>>;
  setSearchTitle: (value: string) => void;
  dealType: DealType;
  handleSearch: (filters?: Filter) => void;
  filteredRegionValue: RegionData[] | null;
  searchTitleValue: string;
  onClosePopup: () => void;
  onSearchTitleChange: (e: React.FormEvent<HTMLInputElement>) => void;
  activePopUp: string;
  handleShowPopup: (ref: RefObject<HTMLElement | null>, name: string) => void;
  inputLocationRef: RefObject<HTMLInputElement | null>;
  groupSearchBlock: RefObject<HTMLDivElement | null>;
  locationValues: string[];
  isLocationActive: boolean;
}

const enum EnumPopUpName {
  location = "location",
}

export default function SearchLocationClassic({
  selectedFilters,
  setSelectedFilters,
  setSearchTitle,
  dealType,
  handleSearch,
  filteredRegionValue,
  searchTitleValue,
  onClosePopup,
  onSearchTitleChange,
  activePopUp,
  handleShowPopup,
  inputLocationRef,
  groupSearchBlock,
  locationValues,
  isLocationActive,
}: SearchLocationClassicProps) {
  const t = useTranslations();
  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  });

  const handleSearchClick = (filters?: Filter) => {
    handleSearch(filters);
    onClosePopup();
  };

  return (
    <Popover
      placement={isMobile ? "top" : "bottom"}
      shouldFlip={!isMobile}
      shouldUpdatePosition={!isMobile}
      isOpen={activePopUp === EnumPopUpName.location}
      onOpenChange={(isOpen) =>
        isOpen
          ? handleShowPopup(
              isMobile ? inputLocationRef : groupSearchBlock,
              EnumPopUpName.location,
            )
          : onClosePopup()
      }
      variant={isMobile ? "fullScreen" : "search"}
    >
      <PopoverTrigger>
        <div className={styles.searchElement__wrapper}>
          <SearchLocationInput
            inputRef={inputLocationRef}
            className={
              "grow md:border-transparent md:shadow-none md:-m-px xl:h-[6.4rem]"
            }
            value={
              locationValues?.length > 0
                ? locationValues?.map((el) => el).join(", ")
                : searchTitleValue
            }
            onChange={onSearchTitleChange}
            placeholder={t("Enter city name")}
            isActive={activePopUp === EnumPopUpName.location}
            isIconActive={isLocationActive}
          />
        </div>
      </PopoverTrigger>
      <PopoverContent variant={isMobile ? "fullScreen" : "search"}>
        <SearchLocation
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          setSearchTitle={setSearchTitle}
          dealType={dealType}
          handleSearch={handleSearchClick}
          filteredRegionValue={filteredRegionValue}
          searchTitleValue={searchTitleValue}
          onClosePopup={onClosePopup}
          onSearchTitleChange={onSearchTitleChange}
        />
      </PopoverContent>
    </Popover>
  );
}
